import { render, staticRenderFns } from "./tabGatheringTrailer.vue?vue&type=template&id=4651f80a&scoped=true&"
import script from "./tabGatheringTrailer.vue?vue&type=script&lang=js&"
export * from "./tabGatheringTrailer.vue?vue&type=script&lang=js&"
import style1 from "./tabGatheringTrailer.vue?vue&type=style&index=1&id=4651f80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651f80a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4651f80a')) {
      api.createRecord('4651f80a', component.options)
    } else {
      api.reload('4651f80a', component.options)
    }
    module.hot.accept("./tabGatheringTrailer.vue?vue&type=template&id=4651f80a&scoped=true&", function () {
      api.rerender('4651f80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailer.vue"
export default component.exports